import { motion, useScroll, useTransform } from "framer-motion";
import Container from "./Container";



import BannerImage from "../assets/banner-image2.jpg";
import Testinonials from "./Testinonials";

import { CARASOUL, FEATURES } from "./constants";
import ProductsCarasoul from "./ProductsCarasoul";
import DroneModelViewer from "./DroneModelViewer";
import Carasoul from "./Carasoul";
import CarasoulCard from "./CarasoulCard";

const scrollToFooter = () => {
  const footer = document.getElementById("footer");
  if (footer) {
    footer.scrollIntoView({ behavior: "smooth" });
  }
};

const DroneModelsData = [
  {
    name: "Drone 1",
    modelUrl: "drone-models/solar-drone.fbx",
  },
];

function Home() {
  const { scrollY } = useScroll();
  const yImage = useTransform(scrollY, [0, 800], [0, -200]); 
  const yContent = useTransform(scrollY, [0, 800], [0, -100]); 
  const opacityContent = useTransform(scrollY, [0, 400], [1, 0.9]); 
  const scaleImage = useTransform(scrollY, [0, 400], [1, 1.1]); 

  return (
    <>
      <div className="relative w-full h-[90vh]">
        <motion.div
          className="absolute inset-0 w-full h-full"
          style={{ y: yImage, scale: scaleImage }}
        >
          <motion.img
            src={BannerImage}
            alt="Hero Banner"
            className="w-full h-full object-fill"
            initial={{ opacity: 0, scale: 1.2 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.5, ease: "easeOut" }}
          />
        </motion.div>

      
        <motion.div
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.5, ease: "easeOut" }}
        >
          <motion.div
            className="w-6 h-10 border-2 border-white rounded-full flex justify-center"
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          >
            <motion.div
              className="w-1 h-3 bg-white rounded-full mt-2"
              animate={{ y: [0, 12, 0] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            />
          </motion.div>
        </motion.div>
      </div>
      <motion.div
        style={{ y: yContent, opacity: opacityContent }}
        className=""
      >
        <div className="md:flex md:container">
          <div className="container pt-20 md:mr-8 md:w-2/4">
            <h1 className="font-extrabold text-5xl text-center md:text-left text-[#20343c]">
              We blend AI and innovation to redefine aerial capabilities
            </h1>
            <p className="leading-loose py-8 text-center md:text-left text-[#20343c]">
              At Cloud One, we see drones not just as flying machine but as
              catalyst for transformation. With a firm commitment to innnovation
              and a vision for the future, we are redefining the possibilities
              of what drones can accomplish in today's rapidly evolving world.
            </p>
            <button
              onClick={scrollToFooter}
              className=" shadow-2xl py-4 px-8 bg-[#20343c] font-bold rounded-lg text-gray-100 block mx-auto md:mx-0"
            >
              Get A Quote
            </button>
          </div>
          <div className="w-full h-full md:h-[500px] sm:h-[500px] md:w-2/4">
          <Carasoul>
            {CARASOUL.map((item) => (
              <CarasoulCard content={item} size={CARASOUL.length}  />
            ))}
          </Carasoul>
          </div>
{/* 
          <div className="w-full h-full md:h-[500px] sm:h-[500px] md:w-2/4">
            {DroneModelsData.map((drone, index) => (
              <DroneModelViewer
                key={index}
                modelUrl={drone.modelUrl}
                zoom={true}
              />
            ))}
          </div> */}
        </div>
      </motion.div>
      <div className="h-full">
        <div className="py-16 text-center">
          <h1 className="container text-5xl font-bold leading-snug text-cloudone-blue">
            What’s Possible With Our Drones{" "}
            <p>Delivery. Defense. Surveillance. Mapping.</p>
          </h1>
          <p className="py-8 font-medium containertext-cloudone-blue"></p>
          <div className="container grid-co lg:grid">
            <div className="pb-0 drone md:pb-0">
            {/* <img
                src={DGIDrone}
                alt="Drone-image"
                className="block w-full h-auto"
              /> */}
               <div className="w-full h-full md:h-[500px] sm:h-[500px]">
              {DroneModelsData.map((drone, index) => (
                <DroneModelViewer
                  key={index}
                  modelUrl={drone.modelUrl}
                  zoom={true}
                />
              ))}
            </div>
            </div>

            {/* <div className="w-full h-full md:h-[500px] sm:h-[500px]">
              {DroneModelsData.map((drone, index) => (
                <DroneModelViewer
                  key={index}
                  modelUrl={drone.modelUrl}
                  zoom={true}
                />
              ))}
            </div> */}
            {FEATURES.map((feature, i) => {
              var ga = "";
              switch (i) {
                case 0:
                  ga = "ecs";
                  break;
                case 1:
                  ga = "vpc";
                  break;
                case 2:
                  ga = "cdt";
                  break;
                case 3:
                  ga = "ao";
                  break;
                default:
                  ga = "";
              }
              return (
                <div
                  style={{ gridArea: `${ga}` }}
                  className="flex flex-col justify-center items-center py-4 w-max-[300px] mx-auto"
                >
                  <span className="w-[48px] h-[48px] text-[32px] flex-shrink-0 text-cloudone-blue bg-cloudone-gradient-four flex justify-center  items-center rounded-lg">
                    {feature.icon}
                  </span>
                  <h1 className="py-4 font-semibold text-cloudone-blue">
                    {feature.main}
                  </h1>
                  <p className="font-light leading-relaxed">
                    {feature.subtext}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* <div className="bg-[#92C83E]">
        <Container className="py-8 md:flex md:justify-between">
          <div className="md:w-2/4">
            <p className="py-4 px-8 w-min text-nowrap bg-[#20343c] text-gray-100 rounded-full mx-auto md:mx-0">
              Drones built for your business
            </p>
            <h1 className="py-4 text-5xl font-bold text-center text-gray-100 md:text-left">
              We Fly so that you can Work 10x Faster
            </h1>
            <p className="my-auto font-light leading-relaxed text-justify text-gray-100">
              Advanced drones, designed for rapid deployment and efficient
              performance, drastically reducing operational time and increasing
              productivity in various applications.
            </p>
          </div>
          <div className="py-8 my-auto md:w-1/3">
            <img src={AirplaneLuggage} alt="" />
          </div>
        </Container>
      </div>
      <div>
        <Container className="relative py-16">
          <div className="">
            <div className="md:w-3/4">
              <h1 className="text-4xl font-bold text-center md:text-left text-cloudone-blue">
                We at Cloudone work as a team to deliver for YOU.
              </h1>
              <p className="py-4 text-cloudone-blue">
                Our Team focuses on extensive R&D to deliver best industrial
                grade tech infused Drones
              </p>
            </div>
            <button
              onClick={scrollToCarousel}
              className="px-8 py-4 mx-auto border-4 rounded-lg sm:block md:absolute md:top-0 md:right-0 md:my-16 border-cloudone-gradient-four"
            >
              Learn More
            </button>
          </div>
          <VideoPlayer />
        </Container>
      </div> */}
      <div id="products-carousel">
        <ProductsCarasoul />
      </div>
      <div className="bg-center bg-cover bg-drone-mountain ">
        <div className="h-full bg-gradient-to-r from-cloudone-gradient-four/45 to-cloudone-gradient-three/45">
          <Container className="py-16 leading-relaxed text-center">
            <h1 className="text-4xl font-bold leading-relaxed text-gray-100 md:text-5xl">
              Environmentally Friendly Operations
            </h1>
            <p className="py-8 leading-loose text-gray-100">
              As a company, we are committed to advancing environmentally
              friendly practices in our drones. We focus on reducing
              environmental impact while supporting critical operations like
              medical evacuations and supply delivery. Our dedication to
              sustainability drives our innovation and development.
            </p>
            <button
              onClick={scrollToFooter}
              className="px-8 py-4 text-gray-100 rounded-full bg-cloudone-gradient-four"
            >
              Contact Us
            </button>
          </Container>
        </div>
      </div>

      <Testinonials />
    </>
  );
}


export default Home;